import { callApi } from './ApiClient';

const DOWNLOAD_HISTORY_ENDPOINT = '/executive_export_histories';
const DOWNLOAD_HISTORY_SUMMARY_ENDPOINT = '/executive_export_histories/summary';
const DOWNLOAD_HISTORY_OVERVIEW_ENDPOINT = '/executive_export_histories/overview';

// ダウンロード履歴のサマリー（同一エクスポート注文を1行に集約した一覧）を取得する
const getDownloadHistorySummary = (data, dispatch) => {
  return callApi('GET', DOWNLOAD_HISTORY_SUMMARY_ENDPOINT, data, dispatch);
}

// ダウンロード履歴の明細（1件ずつのエクスポート対象）を取得する
const getDownloadHistoryDetail = (data, dispatch) => {
  return callApi('GET', DOWNLOAD_HISTORY_ENDPOINT, data, dispatch);
}

// ダウンロード履歴の概要（注文数・ダウンロード件数）を取得する
const getDownloadHistoryOverview = (data, dispatch) => {
  return callApi('GET', DOWNLOAD_HISTORY_OVERVIEW_ENDPOINT, data, dispatch);
}

export const DownloadHistoryApi = {
  getDownloadHistorySummary,
  getDownloadHistoryDetail,
  getDownloadHistoryOverview,
};



// WEBPACK FOOTER //
// ./src/redux/api/DownloadHistoryApi.js